'use strict';
angular.module('resourceCenterMaterialModule').directive('meiziDropdownBox', ['$timeout', 'mediaTagApiService', '$compile',
    function($timeout, mediaTagApiService, $compile) {
        return {
            scope: {
                type: '@',
                selectedItem: '=',
                labelname: '@'
            }, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/materialResource/directive/dropDownBox/index.html',
            replace: true,
            link: function($scope, iEle) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        labels: [],
                        imageurl: $scope.selectedItem.imageurl
                    };
                    $scope.labelname = $scope.labelname || $scope.selectedItem.labelname;
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    bindBlur();
                }

                /**
                 * [enter description] 鼠标移出显示详情
                 *
                 * @param   {[type]}  e     [e description]
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.enter = function(e, item) {
                    $scope.data.labelDetail = item;
                    creteDom();
                    $scope.data.$dom.css({
                        top: e.pageY + e.target.offsetParent.offsetHeight / 2 - e.offsetY + 'px',
                        left: e.pageX + e.target.parentElement.offsetWidth - e.offsetX + 10 + 'px'
                    });
                    $scope.data.$dom.css('display', 'block');
                };

                /**
                 * [creteDom description] 创建气泡弹窗dom
                 *
                 * @return  {[type]}  [return description]
                 */
                function creteDom() {
                    // 创建编译函数
                    var divBox = '<div style="display:none" class="mrizi_label_detail" ng-click="leave()"><div class="triangleBox"><div class="triangle"></div></div><div class="label_detail_img"><img ng-src="{{data.labelDetail.imageurl}}" alt=""></div><div class="label_detail_desc"><p ng-bind="data.labelDetail.labelname"></p><p ng-bind="data.labelDetail.labeldesc"></p></p></div></div>';
                    var compileFn = $compile(divBox);
                    // 传入scope，得到编译好的dom对象(已封装为jqlite对象)
                    // 也可以用$scope.$new()创建继承的作用域
                    $scope.data.$dom = compileFn($scope); 
                    // 添加到文档中
                    $scope.data.$dom.appendTo('body');
                }

                /**
                 * [leave description] 鼠标移入显示详情
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.leave = function () {
                    $scope.data.labelDetail = '';
                    $scope.data.$dom.remove();
                };

                /**
                 * [selected description] 标签选中
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.selected = function(item) {
                    if ($scope.selectedItem.image) {
                        item.image = $scope.selectedItem.image;
                    } else {
                        if (!item.imageurl) {
                            item.imageurl = $scope.data.imageurl;
                        } 
                    }
                    $scope.labelname = item.labelname;
                    $scope.selectedItem = item;
                    $scope.data.labels = [];
                };

                /**
                 * [searchLabel description] 搜索标签
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.searchLabel = function() {
                    $timeout.cancel($scope.labelTimer);
                    if ($scope.labelname === '') {
                        $scope.data.labels = [];
                        $scope.selectedItem.labelname = '';
                        return;
                    }
                    $scope.labelTimer = $timeout(function() {
                        var params = {
                            keyword: $scope.labelname,
                            pageNum: 1,
                            pageSize: 100,
                            type: $scope.type,
                        };
                        $scope.loadingPromis = mediaTagApiService.getTagList(params).then(function(data){
                            if (data.code === '200'){
                                $scope.data.labels = data.datas;
                                $scope.data.labels.push({
                                    labelname: $scope.labelname,
                                    id: 0,
                                }); 
                            }
                        });
                    }, 1000);
                };

                /**
                 * [bindBlur description] 绑定失焦事件
                 * @return {[type]} [description]
                 */
                function bindBlur() {
                    $('body').unbind('click', clickEvent).bind('click', clickEvent);
    
                    /**
                     * [clickEvent description] 点击事件
                     * @param  {[type]} e [description]
                     * @return {[type]}   [description]
                     */
                    function clickEvent(e) {
                        var $target = $(e.target);
                        $scope.data.labels = [];
                        if ($target.parents('.meizi_dropdown_box')[0] === iEle[0]) {
                            // 如果点到按键本身，不失焦
                            return;
                        }
                    }
                    $scope.$on('$destroy', function() {
                        $('body').unbind('click', clickEvent);
                    });
                }
            }
        };
    }
]);
